import { isDefined } from "@grandvisionhq/utils";
import { isCmsPrescriptionEntryKey } from "../../types/types/typeguards.js";
function getPrescriptionEntryList(prescriptionStepEntryTypes) {
  if (!prescriptionStepEntryTypes || prescriptionStepEntryTypes.length === 0) {
    return void 0;
  }
  const entryTypes = prescriptionStepEntryTypes.map((item) => {
    if (!isCmsPrescriptionEntryKey(item.key)) return null;
    return {
      key: item.key,
      title: item.iconTextCompound[0].text,
      icon: !!item.iconTextCompound[0]?.icon ? item.iconTextCompound[0].icon : void 0,
      description: !!item.description.value ? item.description.value : void 0,
      ctaLabel: !!item.ctaLabel ? item.ctaLabel : void 0
    };
  });
  return entryTypes.filter(isDefined);
}
export {
  getPrescriptionEntryList
};
//# sourceMappingURL=get-prescription-entry-list.js.map
